import { render, staticRenderFns } from "./ArticleHotIndexCard.vue?vue&type=template&id=31be29fc&"
import script from "./ArticleHotIndexCard.vue?vue&type=script&lang=js&"
export * from "./ArticleHotIndexCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports